"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const HBIcon_1 = __importDefault(require("../components/HBIcon/HBIcon"));
function BriefcaseClock24Svg(props) {
    return react_1.default.createElement("svg", Object.assign({ width: "24px", height: "24px", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" }, props),
        react_1.default.createElement("desc", null, "Created with Sketch."),
        react_1.default.createElement("g", { id: "briefcase-clock-24", stroke: "none", strokeWidth: 1, fill: "none", fillRule: "evenodd" },
            react_1.default.createElement("path", { d: "M17,9 C20.8659932,9 24,12.1340068 24,16 C24,19.8659932 20.8659932,23 17,23 C15.0671747,23 13.3173135,22.2166372 12.0505893,20.9500842 L10,23 L10,17 L16,17 L13.4650634,19.5361311 C14.3698382,20.4406022 15.6195919,21 17,21 C19.7614237,21 22,18.7614237 22,16 C22,13.2385763 19.7614237,11 17,11 C14.8564514,11 13.02795,12.3488773 12.3170039,14.2441237 L10.444036,13.5411588 C11.4395252,10.8881367 13.9992636,9 17,9 Z M17,2 L17,5 L23,5 L23,9 L21,9 L21,7 L3,7 L3,14 L6,14 L6,13 L8,13 L8,14 L9,14 L9,16 L8,16 L8,17 L6,17 L6,16 L4,16 L4,19 L8,19 L8,21 L2,21 L2,16 L1,16 L1,5 L7,5 L7,2 L17,2 Z M18,12 L18,15.6409091 L19.8431367,17.2292638 L18.7631367,18.6692638 L16,16.5409091 L16,12 L18,12 Z M15,4 L9,4 L9,5 L15,5 L15,4 Z", id: "Combined-Shape", fill: "#000000", fillRule: "nonzero" })));
}
function BriefcaseClock24(_a) {
    var { svgProps } = _a, props = __rest(_a, ["svgProps"]);
    return react_1.default.createElement(HBIcon_1.default, Object.assign({}, props),
        react_1.default.createElement(BriefcaseClock24Svg, Object.assign({}, svgProps)));
}
exports.default = BriefcaseClock24;
//# sourceMappingURL=BriefcaseClock24.js.map